"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("./colors");

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pseudobold = "0 0 .65px ".concat(_colors.coal, ", 0 0 .65px ").concat(_colors.coal);

var StepCircle = function StepCircle(_ref) {
  var size = _ref.size,
      borderWidth = _ref.borderWidth,
      color = _ref.color,
      filled = _ref.filled;
  return _react["default"].createElement("div", {
    value: "step-circle",
    style: {
      flexShrink: 0,
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      border: "".concat(borderWidth, "px solid ").concat(color),
      borderRadius: '100%',
      backgroundColor: filled ? color : 'white'
    }
  });
};

StepCircle.propTypes = {
  size: _propTypes["default"].number.isRequired,
  borderWidth: _propTypes["default"].number.isRequired,
  color: _propTypes["default"].string.isRequired,
  filled: _propTypes["default"].bool
};

var StepHalfCircle = function StepHalfCircle(_ref2) {
  var size = _ref2.size,
      color = _ref2.color;
  return _react["default"].createElement("div", {
    style: {
      flexShrink: 0,
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      borderRadius: '50%',
      border: "2px solid ".concat(color),
      overflow: 'hidden'
    }
  }, _react["default"].createElement("div", {
    style: {
      display: 'inline-block',
      backgroundColor: color,
      height: "".concat(size, "px"),
      width: "".concat(size / 2 - 2, "px")
    }
  }), _react["default"].createElement("div", {
    style: {
      display: 'inline-block',
      backgroundColor: 'white',
      height: "".concat(size, "px"),
      width: "".concat(size / 2 - 2, "px")
    }
  }));
};

StepHalfCircle.propTypes = {
  size: _propTypes["default"].number.isRequired,
  color: _propTypes["default"].string.isRequired
};

var Step =
/*#__PURE__*/
function (_Component) {
  _inherits(Step, _Component);

  function Step() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Step);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Step)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      if (!_this.props.onClick) {
        return;
      }

      _this.props.onClick(_this.props.index, _this.props.name);
    });

    return _this;
  }

  _createClass(Step, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          activeColor = _this$props.activeColor,
          overrideBsStyle = _this$props.overrideBsStyle,
          completed = _this$props.completed,
          onClick = _this$props.onClick,
          tip = _this$props.tip,
          tipDirection = _this$props.tipDirection,
          small = _this$props.small,
          partial = _this$props.partial,
          icon = _this$props.icon,
          children = _this$props.children,
          vertical = _this$props.vertical;
      var color = _colors.slate;
      var filled = completed;
      var size = small ? 14 : 20;

      if (overrideBsStyle) {
        color = (0, _utils.mapBsStyleToColor)(overrideBsStyle, {
          fallback: _colors.slate
        });
      } else if (completed) {
        color = _colors.success.base;
      } else if (active) {
        color = activeColor;
      }

      var indicatorIcon = _react["default"].createElement(StepCircle, {
        color: color,
        borderWidth: active ? small ? 4 : 6 : 2,
        size: size,
        filled: filled
      });

      if (icon && !small) {
        indicatorIcon = _react["default"].createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: "".concat(size, "px"),
            width: "".concat(size, "px"),
            background: color,
            color: 'white',
            borderRadius: '100%'
          }
        }, icon);
      } else if (partial) {
        indicatorIcon = _react["default"].createElement(StepHalfCircle, {
          color: color,
          size: size
        });
      }

      var stepperStyle;
      var indicatorStyle;
      var childrenStyle;

      if (vertical) {
        stepperStyle = {
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        };
        indicatorStyle = {
          display: 'flex',
          justifyContent: 'center'
        };
        childrenStyle = {
          padding: '7px 0',
          marginLeft: '10px',
          textShadow: active ? pseudobold : 'none'
        };
      } else {
        stepperStyle = {
          padding: small ? '0 4px' : '0 14px',
          textAlign: 'center'
        };
        indicatorStyle = {
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: children ? '0' : '14px'
        };
        childrenStyle = {
          padding: '14px 0',
          textShadow: active ? pseudobold : 'none'
        };
      }

      var step = // TODO define stepper styles properly and move to stylesheet
      _react["default"].createElement("div", {
        className: "stepper-step ".concat(onClick ? 'clickable' : ''),
        style: stepperStyle,
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        style: indicatorStyle
      }, indicatorIcon), children && (!small || vertical) ? _react["default"].createElement("div", {
        style: childrenStyle
      }, children) : null);

      return tip ? _react["default"].createElement(_Tooltip["default"], {
        direction: tipDirection,
        contents: tip
      }, step) : step;
    }
  }]);

  return Step;
}(_react.Component);

exports["default"] = Step;
Step.propTypes = {
  index: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  active: _propTypes["default"].bool,
  partial: _propTypes["default"].bool,
  activeColor: _propTypes["default"].string,
  overrideBsStyle: _propTypes["default"].oneOf(['success', 'none', 'warning', 'danger']),
  completed: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  name: _propTypes["default"].string,
  tip: _propTypes["default"].node,
  tipDirection: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
  children: _propTypes["default"].node,
  small: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  vertical: _propTypes["default"].bool
};
Step.defaultProps = {
  tipDirection: 'top'
};